import { Button, EButtonColor } from '@web_opxp/components';
import { AuthSelectors, useTranslation } from '@web_opxp/features';
import { FC, MouseEventHandler, useCallback } from 'react';
import { connect } from 'react-redux';
import { AssetsBaseUrl } from '../assets';
import { getFriendsUrl, redirectExternal } from '../base/historyService';
import { Banner } from '../components/Banner';
import { IState } from '../store/state';
import './GroupAdminBanner.scss';
import * as Selectors from './selectors';

interface IGroupAdminBannerOwnProps {
  userId?: number;
}

export interface IGroupAdminBannerProps extends IGroupAdminBannerOwnProps {
  show: boolean;
  userName?: string;
  session?: string;
}

const iconUrl = `${AssetsBaseUrl}/feature/icons/gad-brain-icon.png`;

export const GroupAdminBannerFC: FC<IGroupAdminBannerProps> = ({ show, session, userName }) => {
  const { language, t } = useTranslation();

  const clickHandler: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      e.preventDefault();
      redirectExternal(getFriendsUrl(), language, session);
    },
    [language, session]
  );

  const bannerTitle = t('Evaluation.GroupAdmin.Banner.Title', { user: userName });
  const buttonTitle = t('Evaluation.GroupAdmin.Banner.ButtonTitle');

  return (
    <Banner show={show} color="blue" isAnimated={false} className="group-admin-banner">
      <div className="group-banner-wrapper">
        <img alt="banner icon" className="group-banner-icon" src={iconUrl} />
        <div className="group-banner-title">
          <p>{bannerTitle}</p>
        </div>
        <Button label={buttonTitle} className="group-banner-button" color={EButtonColor.white} onClick={clickHandler} />
      </div>
    </Banner>
  );
};

export const mapStateToProps = (state: IState, props: IGroupAdminBannerOwnProps) => {
  const hasGroup = Selectors.hasGroup(state);
  const userId = props.userId;
  const show = hasGroup && !!userId;
  const session = AuthSelectors.getToken(state);
  const userName = show ? Selectors.getGroupMemberName(state, userId) : undefined;
  return {
    show,
    userName,
    session,
  };
};

const GroupAdminBanner = connect(mapStateToProps)(GroupAdminBannerFC);
export default GroupAdminBanner;
